import { useMedia } from "react-use"

export function useMediaIsMobile() {
    return useMedia("screen and (max-width: 768px)")
}
